/**
 * Quiet highlight quads over the cells of the cards a hovered replay-feed
 * row mentions. One DOM node per cell key, position + size mutated each
 * frame by GameBoard.updateCellMentionOverlays; React only re-renders when
 * the cellKeys array itself changes.
 */
export default function CellMentionHighlights({ cellKeys, registerRefs }) {
  const keys = Array.from(cellKeys || []);
  if (keys.length === 0) return null;
  return (
    <div aria-hidden="true">
      {keys.map((key) => (
        <div key={key} ref={(el) => registerRefs(key, el)} className="cell-mention-highlight" />
      ))}
    </div>
  );
}
